import { render } from "./USSDCheckin.vue?vue&type=template&id=1b32b38b&scoped=true"
import script from "./USSDCheckin.vue?vue&type=script&lang=js"
export * from "./USSDCheckin.vue?vue&type=script&lang=js"

import "./USSDCheckin.vue?vue&type=style&index=0&id=1b32b38b&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b32b38b"]])

export default __exports__